import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../../utils";

const dummyDownloadDesc = getDummyText(650);

export const dummyDownload = {
    downloadTitle: "Wir sind für sie da!",
    downloadDescription: dummyDownloadDesc,
    linkUrl: "#",
    linkIcon: "chevron-right",
    tag: "whitepaper",
    shortDescription: "01.01.1970 - PDF 1.2MB",
};

export const dummyDownloads = Array(8).fill({ ...dummyDownload });

export const TeaserDownloadTemplate = ({
    downloadTitle = "Wir sind für sie da!",
    downloadDescription = dummyDownloadDesc,
    linkUrl = "#",
    linkIcon = "chevron-right",
    tag = "whitepaper",
}) => {
    return html`
        <ux-iws-link-wrapper class="ux-iws-teaser-download">
            <div class="ux-iws-teaser-download__image-container">
                ${renderStandardPictureElement({
                    width: 420,
                    height: 620,
                })}
            </div>
            <div class="ux-iws-teaser-download__content-container">
                <div class="ux-iws-teaser-download__title-container">
                    <div class="ux-iws-teaser-download__file-info">
                        <span class="ux-tag ux-iws-teaser-download__tag">
                            ${tag}
                        </span>
                        <span slot="file-info" class="ux-text-tiny"
                            >01.01.1970 PDF - 1.2MB</span
                        >
                    </div>
                    <h4
                        class="ux-text-headline ux-text-headline--small ux-u-text-bold ux-u-margin-vertical-5"
                    >
                        ${downloadTitle}
                    </h4>
                </div>
                <div class="ux-iws-teaser-download__body-container">
                    <div class="ux-iws-teaser-download__description-wrapper">
                        <ux-text-lines-limit text-lines="3">
                            <p class="ux-text-normal ux-u-text-bold">
                                ${downloadDescription}
                            </p>
                        </ux-text-lines-limit>
                    </div>
                    <div class="ux-iws-teaser-download__cta-container">
                        <a
                            href="${linkUrl}"
                            slot="link"
                            class="ux-button ux-button--icon-only"
                            title="next"
                            aria-label="next"
                            role="button"
                            ><ux-icon name="${linkIcon}"></ux-icon
                        ></a>
                    </div>
                </div>
            </div>
        </ux-iws-link-wrapper>
    `;
};

export const TeaserDownloadListTemplate = () => html`
    <div class="ux-iws-teaser-download-grid">
        ${dummyDownloads.map((tile) => TeaserDownloadTemplate(tile))}
    </div>
`;

export const generateTeaserDocument = (args) => {
    return html`
        <ux-iws-teaser-download-document
            file-info="${args.fileInfo}"
            file-type="${args.fileType}"
            file-size="${args.fileSize}"
            link="${args.link}"
        >
            <div slot="image">
                ${args.withImage
                    ? html`
                          <img
                              alt="${args.imageAlt}"
                              src="${args.imageSrc}"
                              width="${args.imageWidth}"
                              height="${args.imageHeight}"
                          />
                          ${args.withIcon
                              ? html`<ux-icon name="download" />`
                              : ""}
                      `
                    : ""}
            </div>
            <span slot="title">${args.title}</span>
            <div slot="description">${args.description}</div>
        </ux-iws-teaser-download-document>
    `;
};

export const TeaserDownloadDocumentTemplate = (args = { withImage: true }) =>
    generateTeaserDocument({
        fileInfo: "01/01/2020",
        fileType: "PDF",
        fileSize: "3.5 MB",
        link: "https://trumpf.com.cms.tru/filestorage/TRUMPF_Master/Corporate/Newsroom/Magazines/TRUe-18-Fokus-DE.pdf",
        withImage: args.withImage,
        withIcon: false,
        imageAlt: "Laser Community #36/2023",
        imageSrc: "./mock-assets/images/downloads/example.png",
        imageWidth: 100,
        imageHeight: 132,
        title: "Laser Community #36/2023",
        description: getDummyText(100),
    });

export const TeaserDownloadDocumentListTemplate = (args) => html`
    <div class="ux-iws-teaser-download-grid">
        <div class="ux-row">
            ${Array(8)
                .fill(1)
                .map(
                    () => html`
                        <div class="ux-col-12 ux-col-md-6">
                            ${TeaserDownloadDocumentTemplate(args)}
                        </div>
                    `
                )}
        </div>
    </div>
`;
